/** Deriva cómo pintar una fila del equipo: si coincide por email con quien
 * ha iniciado sesión (/studio/me), muestra su nombre/email reales y la
 * marca «tú»; si no, la fila queda tal cual la semilla del canon. */
import type { PersonaSeed } from "./personas.seed";

export interface PersonaVista { nombre: string; email: string; esTu: boolean }

export function personaVista(p: PersonaSeed, principalEmail: string | undefined, principalNombre: string | undefined): PersonaVista {
  const esTu = principalEmail !== undefined && p.email.toLowerCase() === principalEmail.toLowerCase();
  return {
    nombre: esTu && principalNombre ? principalNombre : p.nombre,
    email: esTu && principalEmail ? principalEmail : p.email,
    esTu,
  };
}
